import { appEventGTag } from "../event";

export const event = (page: "providerInfo" | "providerComparison", providerNameFrom: string) => {
    appEventGTag({
        page,
        eventName: "click",
        eventLocationType: "link_button",
        eventLocationLabel: "Compare to another provider",
        eventLabel: `Click on "Compare to another provider"`,
        providerToCompare: providerNameFrom
    });
};
